/**
 * This component is used to display the power rankings for nationals.
 * WARNING Dummy data
 */
import React from "react";
import AllStarLine from "./AllStarLine";
import {useQuery} from "@tanstack/react-query";
import Loading from "../core/Loading";

const AllStars = ({ divisionData }) => {
  // API request

  const processData = (jsonData) => {
    return jsonData; // Process or map the fetched division data as needed
  };

  const { isLoading, error, data } = useQuery({
    staleTime: Infinity,
    queryKey: ["division", divisionData.id, "allstars"],
    queryFn: () =>
        fetch(
            `${process.env.REACT_APP_BUIHA_API_URL}/division/${divisionData.id}/allstars/`
        )
            .then((res) => res.json())
            .then((json) => {
              return processData(json);
            }),
  });

  if (isLoading) return <Loading />;
  if (error) return "An error has occurred: " + error.message;

  console.log(data.allstars);

  return (
    // Container for all pages
    <>
      <div className="flex flex-col items-start justify-center lg:justify-between mb-3 w-full">
        <div className="lg:block hidden flex flex-col items-start justify-start">
          <h2 className="font-bold mb-4 leading-tight text-xl">All Stars</h2>
        </div>

        <div className="flex flex-col items-start justify-start w-full">
          {Object.entries(data.allstars).map(([key, value]) => (
              <AllStarLine
                  players={value}
                  is_nm={(key==0)}
              />
          ))}
        </div>
      </div>
    </>
  );
};

export default AllStars;
